import PropTypes from 'prop-types';
import React from 'react';

function Panel(props) {
  const { children } = props;

  return (
    <div>
      { children }
    </div>
  );
}

Panel.propTypes = {
  children: PropTypes.node.isRequired,
  /* eslint-disable-next-line react/no-unused-prop-types */
  tabText: PropTypes.string.isRequired,
};

export default Panel;
